<template>
  <div>
    <div v-if="item.vote">
      <div class="custom_view">
        <span class="title">{{item.vote.title}}</span>
        <div class="divider" />

        <div v-for="(option, index) in item.vote.options" :key="index">
          <div class="row">
            <el-radio label="禁用">{{option.option_name}}</el-radio>
            <span class="percent">{{option.total_voted}}人 {{option.format_percent}}</span>
          </div>
          <!-- <el-slider v-model="option.percent" ></el-slider> -->

          <div class="process">
            <div v-bind:style="{width: option.format_percent}"></div>
          </div>
          <div class="divider" />
        </div>
        <span class="buttonText">请下载APP参与投票</span>
      </div>
    </div>
    <div v-else>
      <el-image class="image" :src="item.image" fit="contain" lazy>
        <div slot="placeholder" class="image-slot">
          <span class="dot">图片加载中...</span>
        </div>
      </el-image>
      <span class="desc">{{item.desc}}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "blogDetailItem",
  props: {
    item: {
      type: Object,
      required: true
    }
  }
};
</script>

<style scoped>
.image {
  width: 100%;
  height: auto;
  margin: 8px 0px;
}
.image-slot {
  display: flex;
  justify-content: center;
  align-items: center;
}
.desc {
  color: #736f6f;
  font-size: 16px;
  line-height: 26px;
}
.custom_view {
  display: flex;
  flex-direction: column;
  /* align-items: center;
  justify-content: center; */
  border-radius: 8px;
  margin-top: 10px;
  margin-bottom: 6px;
  border: 1px solid #f3f3f3;
  padding: 10px;
}
.title {
  font-size: 16px;
  color: #242424;
  line-height: 26px;
  font-weight: bold;
  padding-bottom: 10px;
}
.row {
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding-top: 12px;
  padding-bottom: 8px;
}
.divider {
  width: 100%;
  height: 1px;
  background-color: #f3f3f3;
}
.percent {
  color: #736f6f;
  font-size: 16;
  padding-left: 8;
  margin-right: 8;
}
.process {
  width: 100%;
  height: 8px;
  background-color: #e7ecf1;
  margin: 0 auto;
}
.process div {
  height: 8px;
  background: #2397F7;
}
.buttonText {
  font-size: 16px;
  color: #736f6f;
  margin-top: 14px;
  width: 100%;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/BlogDetailItem.vue